module.exports = __webpack_public_path__ + "static/img/client_wechat.c0f0ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client_wechat.png
// module id = SAAu
// module chunks = 2